import { useFragment } from "@apollo/client";

import {
  FeatureFlagsFragment,
  FeatureFlagsFragmentDoc,
} from "@/generated/graphql";

/**
 * Read the singleton FeatureFlags fragment from the cache.
 */
export function useFeatureFlagsFragment() {
  const { data, complete } = useFragment<FeatureFlagsFragment | undefined>({
    fragment: FeatureFlagsFragmentDoc,
    fragmentName: "FeatureFlags",
    from: {
      __typename: "InstitutionFeatures",
    },
  });

  if (data == null || !complete) return null;

  return data;
}
